"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStickyInsetsCss = getStickyInsetsCss;
exports.tableStripedRowsCss = void 0;
var _styles = require("../styles");
var _classes = require("./classes");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var tableStripedRowsCss = exports.tableStripedRowsCss = (0, _styles.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & .", ":nth-of-type(even) {\n    background-color: ", ";\n  }\n\n  & .", ":nth-of-type(odd) {\n    background-color: ", ";\n  }\n"])), _classes.STICKY_TABLE_ROW, function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.paper;
}, _classes.STICKY_TABLE_ROW, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.background.paper;
});
function getStickyInsetsCss(_ref3) {
  var _ref3$stickyInsets = _ref3.stickyInsets,
    stickyInsets = _ref3$stickyInsets === void 0 ? {} : _ref3$stickyInsets;
  var _stickyInsets$rows = stickyInsets.rows,
    rows = _stickyInsets$rows === void 0 ? [] : _stickyInsets$rows,
    _stickyInsets$header = stickyInsets.header,
    header = _stickyInsets$header === void 0 ? [] : _stickyInsets$header,
    _stickyInsets$footer = stickyInsets.footer,
    footer = _stickyInsets$footer === void 0 ? [] : _stickyInsets$footer;
  var styles = '';
  rows.forEach(function (_ref4, rowIndex) {
    var _ref4$leftColumn = _ref4.leftColumn,
      leftColumn = _ref4$leftColumn === void 0 ? [] : _ref4$leftColumn,
      _ref4$rightColumn = _ref4.rightColumn,
      rightColumn = _ref4$rightColumn === void 0 ? [] : _ref4$rightColumn,
      id = _ref4.id;
    var rowSelector = "#".concat(id);
    var zIndex = 2;
    if (header[rowIndex] !== undefined || footer[rows.length - 1 - rowIndex] !== undefined) {
      zIndex = 4;
    }
    styles += "\n      & ".concat(rowSelector, " .").concat(_classes.STICKY_TABLE_CELL, ":nth-child(-n+").concat(leftColumn.length, ") {\n        position: sticky;\n        left: 0px;\n        z-index: ").concat(zIndex, ";\n      }\n\n      & ").concat(rowSelector, " .").concat(_classes.STICKY_TABLE_CELL, ":nth-last-child(-n+").concat(rightColumn.length, ") {\n        position: sticky;\n        right: 0px;\n        z-index: ").concat(zIndex, ";\n      }\n\n    ");
    leftColumn.forEach(function (pos, i) {
      styles += "\n      & ".concat(rowSelector, " .").concat(_classes.STICKY_TABLE_CELL, ":nth-child(").concat(i + 1, ") {\n       left: ").concat(pos, "px;\n      }\n    ");
    });
    rightColumn.forEach(function (pos, i) {
      styles += "\n      & ".concat(rowSelector, " .").concat(_classes.STICKY_TABLE_CELL, ":nth-last-child(").concat(i + 1, ") {\n       right: ").concat(pos, "px;\n      }\n    ");
    });
  });
  styles += "\n    & .".concat(_classes.STICKY_TABLE_ROW, ":nth-child(-n+").concat(header.length, ") .").concat(_classes.STICKY_TABLE_CELL, " {\n     position: sticky;\n     top: 0px;\n     z-index: 3;\n    }\n\n    & .").concat(_classes.STICKY_TABLE_ROW, ":nth-child(-n+").concat(footer.length, ") .").concat(_classes.STICKY_TABLE_CELL, " {\n     position: sticky;\n     bottom: 0px;\n     z-index: 3;\n    }\n  ");
  header.forEach(function (_ref5) {
    var id = _ref5.id,
      insets = _ref5.insets;
    var rowSelector = "#".concat(id);
    insets.forEach(function (pos, i) {
      styles += "& ".concat(rowSelector, " .").concat(_classes.STICKY_TABLE_CELL, ":nth-child(").concat(i + 1, ") { top: ").concat(pos, "px; }");
    });
  });
  footer.forEach(function (_ref6) {
    var id = _ref6.id,
      insets = _ref6.insets;
    var rowSelector = "#".concat(id);
    insets.forEach(function (pos, i) {
      styles += "& ".concat(rowSelector, " .").concat(_classes.STICKY_TABLE_CELL, ":nth-child(").concat(i + 1, ") { bottom: ").concat(pos, "px; }");
    });
  });
  return (0, _styles.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), styles);
}